import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin, Facebook, Twitter, Instagram } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-gray-900 border-t border-gray-800">
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-8">
          {/* About */}
          <div itemScope itemType="https://schema.org/Organization">
            <Link to="/" data-discover="true" className="flex items-center space-x-2 mb-4">
              <img 
                src="/images/favicon.webp" 
                alt="Galo Bet"
                itemProp="logo"
                className="h-8 w-8 object-contain"
              />
              <h3 className="text-2xl font-bold bg-gradient-to-r from-pink-400 to-pink-600 bg-clip-text text-transparent" itemProp="name">
                Galo Bet
              </h3>
            </Link>
            <p className="text-gray-400 text-sm leading-relaxed mb-4" itemProp="description">
              Votre comparateur indépendant de sites de paris en ligne en France. Nous vous aidons à trouver les meilleures offres et à parier en toute sécurité.
            </p>
            </div>








          <div className="space-y-3 text-sm font-semibold uppercase tracking-wide">
            <p className="text-xs font-medium uppercase tracking-[0.25em] text-accent">Navigation</p>
            <Link to="/" data-discover="true" itemProp="url" className="block text-gray-400 transition hover:text-pink-400">Accueil</Link>
            <Link to="/guides" data-discover="true" itemProp="url" className="block text-gray-400 transition hover:text-pink-400">Guides</Link>
            <Link to="/reviews" data-discover="true" itemProp="url" className="block text-gray-400 transition hover:text-pink-400">Avis</Link>
            <Link to="/news" data-discover="true" itemProp="url" className="block text-gray-400 transition hover:text-pink-400">Actualités</Link>
          </div>
          <div className="space-y-3 text-sm font-semibold uppercase tracking-wide">
            <p className="text-xs font-medium uppercase tracking-[0.25em] text-accent">Légal</p>
            <Link to="/privacy-policy" data-discover="true" itemProp="url" className="block text-gray-400 transition hover:text-pink-400">Politique de confidentialité</Link>
            <Link to="/terms" data-discover="true" itemProp="url" className="block text-gray-400 transition hover:text-pink-400">Conditions générales</Link>
            <Link to="/cookies" data-discover="true" itemProp="url" className="block text-gray-400 transition hover:text-pink-400">Politique cookies</Link>
            <Link to="/responsible-gaming" data-discover="true" itemProp="url" className="block text-gray-400 transition hover:text-pink-400">Jeu responsable</Link>
          </div>
          <div className="space-y-4 text-sm font-semibold uppercase tracking-wide">
            <p className="text-xs font-medium uppercase tracking-[0.25em] text-accent">Jeu responsable</p>
            <div className="grid grid-cols-2 gap-3">
              <a
                  href="https://www.anj.fr/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center justify-center p-2 bg-gray-800 rounded-lg hover:bg-gray-700 transition"
              >
                <img src="/images/logo-anj.svg" alt="ANJ - Autorité Nationale des Jeux" className="h-12 w-auto object-contain" loading="lazy" decoding="async" />
              </a>
              <a
                  href="https://www.evalujeu.fr/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center justify-center p-2 bg-gray-800 rounded-lg hover:bg-gray-700 transition"
              >
                <img src="/images/evalu.svg" alt="EvaluJeu" className="h-12 w-auto object-contain" loading="lazy" decoding="async" />
              </a>
              <a
                  href="https://www.sosjoueurs.org/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center justify-center p-2 bg-gray-800 rounded-lg hover:bg-gray-700 transition"
              >
                <img src="/images/sos.svg" alt="SOS Joueurs" className="h-12 w-auto object-contain" loading="lazy" decoding="async" />
              </a>
              <a
                  href="https://www.sosjoueurs.org/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center justify-center p-2 bg-gray-800 rounded-lg hover:bg-gray-700 transition"
              >
                <img src="/images/18+.svg" alt="18+" className="h-12 w-auto object-contain" loading="lazy" decoding="async" />
              </a>
            </div>
            </div>
            








        </div>

        {/* Disclaimer */}
        <div className="border-t border-gray-800 pt-8 mt-8">
          <p className="text-gray-500 text-xs leading-relaxed max-w-4xl">
            Galo Bet est un site indépendant de comparaison et d'évaluation. Certains liens présents sur nos pages sont des liens d'affiliation, ce qui signifie que nous pouvons recevoir une commission si vous cliquez ou vous inscrivez via ces liens. Cela n'influence jamais nos avis, évaluations ou classements. Réservé aux personnes de 18 ans et plus. Jouez de manière responsable - consultez{' '}
            <a
              href="https://www.joueurs-info-service.fr/"
              target="_blank"
              rel="noopener noreferrer"
              className="text-pink-400 hover:text-pink-300 underline"
            >
              Joueurs Info Service
            </a>
            . Les conditions générales s'appliquent.
          </p>
        </div>

        {/* Copyright */}
        <div className="border-t border-gray-800 pt-6 mt-6 text-center">
          <p className="text-gray-500 text-sm" itemProp="copyrightHolder">
            © {new Date().getFullYear()} <span itemProp="name">Galo Bet</span>. Tous droits réservés.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;

